import { render, staticRenderFns } from "./PaymentCreditsForm.vue?vue&type=template&id=064cc10e"
import script from "./PaymentCreditsForm.vue?vue&type=script&lang=js"
export * from "./PaymentCreditsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports